import { render, staticRenderFns } from "./NewsCenterDetails1.vue?vue&type=template&id=09b4c520&scoped=true"
import script from "./NewsCenterDetails1.vue?vue&type=script&lang=js"
export * from "./NewsCenterDetails1.vue?vue&type=script&lang=js"
import style0 from "./NewsCenterDetails1.vue?vue&type=style&index=0&id=09b4c520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b4c520",
  null
  
)

export default component.exports